import React from 'react';
import { Reveal } from './Reveal';
import { useCountdown } from '../hooks/useCountdown';
export function CountdownSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="w-full bg-navy px-5 py-20 text-white sm:px-8" data-id="element-51" data-mp="3duqgburt1l0z">
      <div className="mx-auto w-full max-w-3xl text-center" data-id="element-52" data-mp="3drvx26kj2695">
        <Reveal data-id="element-53" data-mp="39ru72uo5n19p">
          <p className="inline-block rounded-full bg-gold px-4 py-1.5 text-[11px] font-bold uppercase tracking-widest text-navy" data-id="element-54" data-mp="39rc0p57s36o2">
            Limited launch price
          </p>

          <h2 className="mt-6 font-display text-3xl font-extrabold tracking-tight sm:text-4xl" data-id="element-55" data-mp="3isil3pdjt1ml">
            Launch Price Ends In:
          </h2>

          <div className="mt-8 flex items-start justify-center gap-3 sm:gap-6" data-id="element-56" data-mp="3sj4tayixqpv9">
            {[{
            value: hours,
            label: 'HRS'
          }, {
            value: minutes,
            label: 'MIN'
          }, {
            value: seconds,
            label: 'SEC'
          }].map((unit, index) => <React.Fragment key={unit.label} data-id="element-57" data-mp="5g8bs312onm4" data-mpi={index}>
                {index > 0 && <span aria-hidden="true" className="font-display text-4xl font-extrabold text-cheer/50 sm:text-6xl" data-id="element-58" data-mp="1dnkpa5vv801f">
                    :
                  </span>}
                <div data-id="element-59" data-mp="1sjagqjjtl5dj">
                  <p className="font-display text-5xl font-black tabular-nums tracking-tight text-cheer sm:text-7xl" data-id="element-60" data-mp="1sjk7i9covgka">
                    {unit.value}
                  </p>
                  <p className="mt-2 text-[11px] font-bold uppercase tracking-widest text-white/50" data-id="element-61" data-mp="21jyt79tkexob">
                    {unit.label}
                  </p>
                </div>
              </React.Fragment>)}
          </div>

          <p className="mt-8 text-base font-semibold text-white/80" data-id="element-62" data-mp="2b8qgv5rlevtf">
            After that, the price goes up and bonuses are removed.
          </p>

          <div className="mx-auto mt-10 max-w-xl" data-id="element-63" data-mp="2g71t1n5d1iet">
            <div className="h-2 w-full overflow-hidden rounded-full bg-white/10" data-id="element-64" data-mp="2kbhvfefrm7pa">
              <div className="h-full rounded-full bg-cheer" style={{
              width: '78%'
            }} data-id="element-65" data-mp="l4wzjpjc2am3" />
            </div>
            <div className="mt-3 flex items-center justify-between text-[11px] font-bold uppercase tracking-wider" data-id="element-66" data-mp="g7eptwxhrrd1">
              <span className="text-gold" data-id="element-67" data-mp="tythst9dn2w8">Limited spots</span>
              <span className="text-white/60" data-id="element-68" data-mp="p7juhzbawbni">78% claimed</span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}